import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import { DEFAULT_PAGE_SIZE, SIMPLE_BILLING } from '../../../../utils/Constants';
import MessageUtils from "../../../../utils/MessageUtils";
import { LOADING, SAVE_PAYMENT_SETTINGS_SUCCESS, GET_SERVICE_FEES_SUCCESS, GET_PAYMENT_PROVIDERS_SUCCESS, SAVE_SUBSCRIPTION_SUCCESS, GET_SUBSCRIPTION_SUCCESS, LOAD_ADDITIONAL_CHARGES_SUCCESS, CREATE_ADDITIONAL_CHARGE_SUCCESS, LOAD_COMPANY_INFO_SUCCESS, LOAD_BANK_ACCOUNT_SUCCESS, LOAD_INVOICES_SUCCESS, GET_SYSTEM_STATISTIC_SUCCESS, GET_INVOICE_COLLECTION_SUCCESS, GET_MONTHLY_SYSTEM_STATISTIC_SUCCESS, GET_MONTHLY_PAYABLE_RECON_SUCCESS, LOAD_ADDITIONAL_CHARGES_HISTORY_SUCCESS, GET_INVOICE_DATA_SUCCESS } from "../../../types";
import { getSelectedPaymentType } from "../../../../utils/CommonUtils";

export const getPaymentProviders = () => {
    return (dispatch, getState) => {
        const url = `/provider-type`;

        axios().get(url)
            .then(res => getPaymentProvidersSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingPaymentProvidersFailure')));
    }
}

const getPaymentProvidersSuccess = (res, dispatch) => {
    dispatch({ type: GET_PAYMENT_PROVIDERS_SUCCESS, payload: res.data });
}

export const getPaymentSettings = (restaurantId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/payment-settings`;

        axios().get(url)
            .then(response => getPaymentSettingsSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.connectWithStripeFailure')));
    };
};


const getPaymentSettingsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    const paymentData = {
        id: response.data.id,
        paymentCode: response.data.paymentCode,
        providerType: response.data.providerType,
        settings: response.data.settings,
        selectedPaymentType: getSelectedPaymentType(response.data.simpleBilling)
    };

    dispatch({ type: SAVE_PAYMENT_SETTINGS_SUCCESS, payload: paymentData });

    if (callback && paymentData.connectedAccountId) { // TODOooo what does this button do?????
        callback();
    }
}

export const updatedPaymentSettings = (state, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/payment-settings/${state.paymentSettingsId}`;
        let updateObject = {
            id: state.paymentSettingsId,
            providerType: state.selectedPaymentType === SIMPLE_BILLING? {
                id: 3,
                value: 'Mollie'
            } : state.providerType,
            simpleBilling: state.selectedPaymentType === SIMPLE_BILLING? true : false,
            paymentCode: state.paymentCode,
            settings: JSON.stringify(state.settings)
        }

        axios().put(url, updateObject)
            .then(res => updatedPaymentSettingsSuccess(res, dispatch))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.savingPaymentCodeFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const updatedPaymentSettingsSuccess = (response, dispatch) => {
    dispatch({ type: LOADING, payload: false });

    const paymentData = {
        id: response.data.id,
        paymentCode: response.data.paymentCode,
        providerType: response.data.providerType,
        settings: response.data.settings,
        selectedPaymentType: getSelectedPaymentType(response.data.simpleBilling)
    };

    dispatch({ type: SAVE_PAYMENT_SETTINGS_SUCCESS, payload: paymentData });

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.savingPaymentSuccess'));
};

export const resetPayment = (restaurantId, callback) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/reset-payment`;

        axios().put(url, {})
            .then(response => resetPaymentSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.resetPaymentCodeFailure')));
    };
};

const resetPaymentSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    const paymentData = {
        id: response.data.id,
        paymentCode: response.data.paymentCode,
        providerType: response.data.providerType,
        settings: response.data.settings,
        selectedPaymentType: getSelectedPaymentType(response.data.simpleBilling)
    };

    dispatch({ type: SAVE_PAYMENT_SETTINGS_SUCCESS, payload: paymentData });

    if (callback) {
        callback();
    }

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.resetPaymentCodeSuccess'));
};

export const getRestaurantServiceFees = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/service-fees`;

        axios().get(url)
            .then(res => getRestaurantServiceFeesSuccess(dispatch, res.data))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingServiceFeeFailure')));
    }
}

const getRestaurantServiceFeesSuccess = (dispatch, res) => {
    dispatch({ type: GET_SERVICE_FEES_SUCCESS, payload: res });
}

export const updateRestaurantServiceFees = (serviceFees, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${getState().restaurant.id}/service-fees`;

        axios().put(url, serviceFees)
            .then(res => updateRestaurantServiceFeesSuccess(dispatch, res.data, callback))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data));
    }
}

const updateRestaurantServiceFeesSuccess = (dispatch, res, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: GET_SERVICE_FEES_SUCCESS, payload: res });

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.updateServiceFeeSucces'));
    callback();
}

export const saveSubscription = (state, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `restaurant-subscription/restaurant/${getState().restaurant.id}`;

        let subscription = {
            fixedPriceSubscription: state.fixedPriceRate.fixedPriceRateAmount || state.fixedPriceRate.fixedPriceRateDate ||  state.fixedPriceRate.subscriptionNote ? {
                amount: Number(state.fixedPriceRate.fixedPriceRateAmount),
                startTime: state.fixedPriceRate.fixedPriceRateDate,
                note: state.fixedPriceRate.subscriptionNote
            } : null,
            pricePerOrderSubscription: state.fixedPricePerOrder.fixedPricePerOrderAmount || state.fixedPricePerOrder.fixedPricePerOrderDate || state.fixedPricePerOrder.subscriptionNote ? {
                amount: Number(state.fixedPricePerOrder.fixedPricePerOrderAmount),
                startTime: state.fixedPricePerOrder.fixedPricePerOrderDate,
                note: state.fixedPricePerOrder.subscriptionNote
            } : null,
            percentPerOrderSubscription: state.percentFromOrderTotal.percentFromOrderTotalAmount || state.percentFromOrderTotal.percentFromOrderTotalDate || state.percentFromOrderTotal.subscriptionNote ? {
                amount: Number(state.percentFromOrderTotal.percentFromOrderTotalAmount),
                startTime: state.percentFromOrderTotal.percentFromOrderTotalDate,
                note: state.percentFromOrderTotal.subscriptionNote
            } : null,
            recurringCharges: state.recurringCharges,
            taxPercent: state.taxPercent,
            smsFee: state.smsFee
        };

        axios().post(url, subscription)
            .then(response => saveSubscriptionSuccess(dispatch, response, callback))
            .catch(error => saveSubscriptionError(dispatch, error));
    };
};

const saveSubscriptionSuccess = (dispatch, response, callback) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: SAVE_SUBSCRIPTION_SUCCESS, payload: response.data });

    if(callback) {
        callback()
    }

};

const saveSubscriptionError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('screens:paymentScreen.saveSubscriptionFailure'));
    } else {
        dispatch({ type: LOADING, payload: false });
    }
}

export const getSubscription = (restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-subscription/restaurant/${restaurantId}`;

        axios().get(url)
            .then(response => getSubscriptionSuccess(dispatch, response.data))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingSubscriptionFailure')));
    }
}

const getSubscriptionSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: GET_SUBSCRIPTION_SUCCESS, payload: response });
}

export const createAdditionalCharge = (state, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `restaurant/${getState().restaurant.id}/additional-charge`;

        let additionalCharge = {
           type: state.type.toUpperCase(),
           week: state.week,
           year: state.year,
           name: state.name,
           description: state.description ? state.description : '',
           amount: Number(state.amount)
        };

        axios().post(url, additionalCharge)
            .then(response => createAdditionalChargeSuccess(dispatch, response, callback))
            .catch(error => createAdditionalChargeError(dispatch, error))
    };
};

const createAdditionalChargeSuccess = (dispatch, response, callback) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: CREATE_ADDITIONAL_CHARGE_SUCCESS, payload: response.data });

    if(callback) {
        callback()
    }
};

const createAdditionalChargeError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.loadAdditionalChargesFailure'));
    } else {
        dispatch({ type: LOADING, payload: false });
    }
}

export const loadAdditionalCharges = (restaurantId, currentPageNumber) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        if (!restaurantId) return dispatch({ type: LOADING, payload: false });
        const url = `/additional-charge/search?page=${currentPageNumber}&size=${DEFAULT_PAGE_SIZE}&restaurantId=${restaurantId}`;

        axios().get(url)
            .then(response => loadAdditionalChargesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.loadAdditionalChargesFailure')));
    }
}

const loadAdditionalChargesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ADDITIONAL_CHARGES_SUCCESS, payload: response.data });
}

export const deleteAdditionalCharge = (id, loadAdditionalCharges) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/additional-charge/${id}`;

        axios().delete(url)
            .then(response => deleteAdditionalChargeSuccess(dispatch, loadAdditionalCharges))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, i18n.t('actions:paymentActions.deleteAdditionalChargeFailure')));
    }
};

const deleteAdditionalChargeSuccess = (dispatch, loadAdditionalCharges) => {
    dispatch({ type: LOADING, payload: false });
    loadAdditionalCharges();
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.deleteAdditionalChargeSuccess'));
};

export const updateAdditionalCharge = (additionalCharge, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/additional-charge/${additionalCharge.id}`;

        let updatedAdditionalCharge = {
            type: additionalCharge.type.toUpperCase(),
            week: additionalCharge.week,
            year: additionalCharge.year,
            name: additionalCharge.name,
            description: additionalCharge.description ? additionalCharge.description : '',
            amount: Number(additionalCharge.amount)
         };

        axios().put(url, updatedAdditionalCharge)
            .then(response => updateAdditionalChargeSuccess(dispatch, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, i18n.t('actions:paymentActions.updateAdditionalChargeFailure')));
    }
}

const updateAdditionalChargeSuccess = (dispatch, callback) => {

    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.updateAdditionalChargeSuccess'));
}

export const importAdditionalChargesCSV = (restaurantId, additionalChargesCSV, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-additional-charges-csv`;
        const header = { headers: { 'Content-Type': 'multipart/form-data' } }

        const formData = new FormData();
        const file = 'file';
        formData.append(file, additionalChargesCSV);

        axios().post(url, formData, header)
            .then(response => importAdditionalChargesCSVSuccess(dispatch, response, restaurantId, callback, header))
            .catch(error => importAdditionaChargesCSVError(dispatch, error));
    };
};

const importAdditionaChargesCSVError = (dispatch, error) => {
    dispatch({ type: LOADING, payload: true });
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.importAdditionalChargesCSVFailure'));
    } else {
        console.log(error);
    }
}

const importAdditionalChargesCSVSuccess = (dispatch, response, restaurantId, callback, header) => {

    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.importAdditionalChargesCSVSuccess'));
};

export const saveCompanyInfo = (state, restaurantId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/company-info`;

        let updatedCompanyInfo = {
            name: state.name,
            primaryEmail: state.primaryEmail,
            secondaryEmail: state.secondaryEmail,
            taxId: state.taxId,
            taxPercent: Number(state.taxPercent),
            taxValid: state.taxValid,
            address: {
                street: state.street,
                streetNumber: state.streetNumber,
                city: state.city,
                country: state.country,
                zipCode: state.zipCode
            }
        }

        axios().put(url, updatedCompanyInfo)
            .then(res => saveCompanyInfoSuccess(res, dispatch, callback))
            .catch(err => saveCompanyInfoError(dispatch, err))
    }
}

const saveCompanyInfoSuccess = (res, dispatch, callback) => {

    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.saveCompanyInfoSuccess'));
};

const saveCompanyInfoError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('screens:paymentActions.saveCompanyInfoFailure'));
    } else {
        dispatch({ type: LOADING, payload: false });
    }
}

export const loadCompanyInfo = (restaurantId) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/company-info`;
        
        axios().get(url)
            .then(response => loadCompanyInfoSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.loadingCompanyInfoFailure')));
    }
}

const loadCompanyInfoSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_COMPANY_INFO_SUCCESS, payload: response.data });
}

export const saveBankAccount = (state, restaurantId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/bank-account`;

        let updatedBankAccount = {
            bankCountry: state.bankCountry,
            bankCurrency: state.bankCurrency,
            bankAddress: state.bankAddress,
            bankNumber: state.bankNumber,
            area: state.area,
            iban: state.iban,
            bic: state.bic,
            accountNumber: state.accountNumber,
            type: state.type
        }

        axios().put(url, updatedBankAccount)
            .then(res => saveBankAccountSuccess(res, dispatch, callback))
            .catch(err => saveBankAccountError(dispatch, err))
    }
}

const saveBankAccountSuccess = (res, dispatch, callback) => {

    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:paymentActions.saveBankAccountSuccess'));
};

const saveBankAccountError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.saveBankAccountFailure'));
    } else {
        dispatch({ type: LOADING, payload: false });
    }
}

export const loadBankAccount = (restaurantId) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/bank-account`;

        axios().get(url)
            .then(response => loadBankAccountSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.loadingBankAccountFailure')));
    }
}

const loadBankAccountSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_BANK_ACCOUNT_SUCCESS, payload: response.data });
}

export const getInvoices = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        

        let updatedSearchQuery = { ...searchQuery };

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `/invoice/search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => getInvoicesSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingInvoicesFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }

}

const getInvoicesSuccess = (res, dispatch, getState) => {
    dispatch({ type: LOAD_INVOICES_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });
}

export const downloadInvoice = (restaurantId, week, month, year, invoiceNumber) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        const updatedWeek = week ? `&week=${week}` : '';
        const updatedMonth = month ? `&month=${month}` : '';
        const updatedInvoiceNumber = invoiceNumber ? `&invoiceNumber=${invoiceNumber}` : '';
        const url = `/invoice/download?restaurantId=${restaurantId}${updatedWeek}${updatedMonth}&year=${year}${updatedInvoiceNumber}`;
        const fileName = `${invoiceNumber ? `InvoiceNumber-${invoiceNumber}` : 'invoice'}-${week ? `week-${week}` : `month-${month}`}-year-${year}-RestaurantID-${restaurantId}.pdf`;

        axios().get(url, { responseType: 'blob' })
        .then(response => {
            dispatch({ type: LOADING, payload: false });
            let blob = new Blob([response.data], { type: 'application/pdf' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName
            link.click();
            // let pdfURL = window.URL.createObjectURL(blob);
            // window.open(pdfURL, '_blank');
        })
        .catch(error => {
            dispatch({ type: LOADING, payload: false });
            console.log('ERROR', error)
        })
    }
};

export const getSystemStatisticDashboard = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        

        let updatedSearchQuery = { ...searchQuery };

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `/menuu-revenue/search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => getSystemStatisticDashboardSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingSystemStatisticFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }

}

const getSystemStatisticDashboardSuccess = (res, dispatch, getState) => {
    dispatch({ type: GET_SYSTEM_STATISTIC_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });
}

export const downloadRevolutFile = (week, year, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `menuu-revenue/download-revolut?week=${week}&year=${year}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `revolut-file-week-${week}-year-${year}.csv`;
                link.click();
                if (callback) {
                    callback();
                }
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const getInvoiceCollection = (pageNumber, week, year, restaurantId, callback, billingTypeIndex) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        
        const updatedBillingTypeIndex = billingTypeIndex ? `&billingType=${billingTypeIndex}` : '';

        const currentRestaurantId = restaurantId ? `&restaurantId=${restaurantId}` : '';
        const url = `invoice/week-revenue-search?page=${pageNumber}&size=${DEFAULT_PAGE_SIZE}${currentRestaurantId}&week=${week}&year=${year}${updatedBillingTypeIndex}`;

        axios().get(url)
            .then(res => getInvoiceCollectionSuccess(res, dispatch, getState, callback))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingInvoiceCollectionFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }

}

const getInvoiceCollectionSuccess = (res, dispatch, getState, callback) => {
    dispatch({ type: GET_INVOICE_COLLECTION_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
}

export const getMonthlyPayableReconciliation = (pageNumber, month, year, restaurantId, billingTypeIndex, callback) => {
    
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });
        
        const updatedBillingTypeIndex = billingTypeIndex ? `&billingType=${billingTypeIndex}` : '';

        const currentRestaurantId = restaurantId ? `&restaurantId=${restaurantId}` : '';
        const url = `invoice/month-revenue-search?page=${pageNumber}&size=${DEFAULT_PAGE_SIZE}${currentRestaurantId}&month=${month}&year=${year}${updatedBillingTypeIndex}`;

        axios().get(url)
            .then(res => getMonthlyPayableReconciliationSuccess(res, dispatch, getState, callback))
            .catch(err => {
                console.log(err)
                MessageUtils.errorMessageResponse(dispatch, i18n.t('actions:paymentActions.loadingInvoiceCollectionFailure'))
            })
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const getMonthlyPayableReconciliationSuccess = (res, dispatch, getState, callback) => {
    dispatch({ type: GET_MONTHLY_PAYABLE_RECON_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });

    if(callback) {
        callback()
    }
}

export const downloadAccountingFiles = (week, year, month, billingType) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const weekQuery = week ? `?week=${week}` : '';
        const monthQuery = month ? `?month=${month}` : '';
        const yearQuery = year ? `&year=${year}` : '';
        const billingTypeQuery = billingType ? `&billingType=${billingType}` : '';

        const fileName = billingType === 1 ? `accounting-simple-billing-file-${week ? `week-${week}` : `month-${month}`}-year-${year}.csv` : `accounting-advanced-billing-file-${week ? `week-${week}` : `month-${month}`}-year-${year}.csv`;

        const url = `invoice/download-accounting-report${weekQuery}${monthQuery}${yearQuery}${billingTypeQuery}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const getMonthlySystemStatisticDashboard = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        

        let updatedSearchQuery = { ...searchQuery };

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `menuu-revenue/monthly-search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => getMonthlySystemStatisticDashboardSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingSystemStatisticFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const getMonthlySystemStatisticDashboardSuccess = (res, dispatch, getState) => {
    dispatch({ type: GET_MONTHLY_SYSTEM_STATISTIC_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });
}

export const downloadXeroFile = (week, year, month) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const weekQuery = week ? `?week=${week}` : '';
        const monthQuery = month ? `?month=${month}` : '';
        const yearQuery = year ? `&year=${year}` : '';

        const fileName = `xero-file-${week ? `week-${week}` : `month-${month}`}-year-${year}.csv`;

        const url = `invoice/download-xero-report${weekQuery}${monthQuery}${yearQuery}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const downloadInvoices = (restaurantId, month, year) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const updatedMonth = month ? `&month=${month}` : '';
        const url = `/invoice/download-invoices?restaurantId=${restaurantId}${updatedMonth}&year=${year}`;
        const fileName = `invoices-${`month-${month}`}-year-${year}-RestaurantID-${restaurantId}.csv`;

        axios().get(url, { responseType: 'blob' })
        .then(response => {
            dispatch({ type: LOADING, payload: false });
            let blob = new Blob([response.data], { type: 'application/csv' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        })
        .catch(error => {
            dispatch({ type: LOADING, payload: false });
            console.log('ERROR', error)
        })
    }
};

const getQueryParams = (pageNumber, searchQuery) => {

    const {
        week,
        month,
        year,
        restaurantId,
        invoiceNumber
    } = searchQuery;
    let pageParam = '',
        sizeParam = '',
        restaurantIdParam = '',
        weekParam = '',
        monthParam = '',
        yearParam = '',
        invoiceNumberParam = '';
    pageParam = pageNumber;
    // sizeParam = 10;

    if (restaurantId) {
        restaurantIdParam = `&restaurantId=${restaurantId}`
    }

    if (week) {
        weekParam = `&week=${week}`
    }

    if (month) {
        monthParam = `&month=${month}`
    }

    if (year) {
        yearParam = `&year=${year}`
    }

    if (invoiceNumber) {
        invoiceNumberParam = `&invoiceNumber=${invoiceNumber}`
    }

    return `page=${pageParam}&size=${DEFAULT_PAGE_SIZE}${restaurantIdParam}${weekParam}${monthParam}${yearParam}${invoiceNumberParam}`;
}

export const downloadInvoiceHistory = (restaurantId, startDate, endDate, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const fileName = `invoices_${restaurantId}_${startDate}/${endDate}.csv`;

        const url = `restaurant/${restaurantId}/invoice-history?startDate=${startDate}&endDate=${endDate}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();

                if(callback) {
                    callback()
                }
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const downloadAccountPayableTable = (month, year, restaurantId, billingTypeIndex, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const restaurantIdParam = restaurantId ? `&restaurantId=${restaurantId}` : '';
        const billingTypeParam = billingTypeIndex ? `&billingType=${billingTypeIndex}` : '';
        const restaurantIdFileName = restaurantId ? `_Id-${restaurantId}` : '';
        const billingTypeFileName = billingTypeIndex ? `_${billingTypeIndex === 1 ? 'Simple' : billingTypeIndex === 2 ? 'Advanced' : ''}` : '';


        const url = `invoice/download-month-revenues?month=${month}&year=${year}${restaurantIdParam}${billingTypeParam}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Month-${month}_${year}${restaurantIdFileName}${billingTypeFileName}_Revenues.csv`;
                link.click();
                if (callback) {
                    callback();
                }
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const loadAdditionalChargesHistory = (restaurantId, currentPageNumber) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        if (!restaurantId) return dispatch({ type: LOADING, payload: false });
        const url = `/additional-charge-history/search?page=${currentPageNumber}&size=${DEFAULT_PAGE_SIZE}&restaurantId=${restaurantId}`;

        axios().get(url)
            .then(response => loadAdditionalChargesHistorySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:paymentActions.loadAdditionalChargesFailure')));
    }
}

const loadAdditionalChargesHistorySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ADDITIONAL_CHARGES_HISTORY_SUCCESS, payload: response.data });
}

export const getDataBasedOnInvoiceNumberSearch = (pageNumber, searchQuery, invoiceNumber) => {
    
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        let updatedSearchQuery = { ...searchQuery };
        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const updatedInvoiceNumber = invoiceNumber ? `&invoiceNumber=${invoiceNumber}` : '';

        const url = `invoice/invoice-number-search?${finalSearchQuery}${updatedInvoiceNumber}`;

        axios().get(url)
        .then(res => getDataBasedOnInvoiceNumberSearchSuccess(res, dispatch, getState))
        .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:paymentActions.loadingSystemStatisticFailure')))
    }
}

const getDataBasedOnInvoiceNumberSearchSuccess = (res, dispatch, getState) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: GET_INVOICE_DATA_SUCCESS, payload: res.data });
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/restaurant/PaymentActions.js